import React from "react"
import {
	ATELIER_ETAT_CLOS,
	ATELIER_ETAT_EN_ATTENTE_PAIEMENT,
} from "../../utilities/Addons"
import { useDispatch, useSelector } from "react-redux"
import { postAtelier } from "../../store/actions/atelierActions"
import { useAtelierPermissions } from "../../hooks/ateliers"
import FacturationModalV2 from "../others/FacturationModalV2"

// « Facturer » de la fiche atelier : la modale est commune avec la location
// (others/FacturationModalV2, Jordan 30.10) — upload des factures par
// transaction puis transition d'état (CLOS si tout en moyen "facture", sinon
// EN_ATTENTE_PAIEMENT). `post` : gardé pour l'appelant, plus lu (la modale
// affiche elle-même sauvegarde / erreur / fin).
const FacturationCustomModalV2 = ({
	aFacturer,
	onClose,
	updateEtatAndSave,
	getAtelierJson,
	reloadFiche,
	lignesNonEnregistrees = 0,
}) => {
	const dispatch = useDispatch()
	const { atelier } = useSelector((state) => state.atelierInfo)
	// Sans droit de clôture, la facturation passe « En attente de paiement »,
	// jamais Clos (aujourd'hui : boss, admin et assistant_admin closent).
	const { canClore } = useAtelierPermissions()

	const onFactures = (transactions, toutesFacture) => {
		const json = getAtelierJson()
		json.atelier = {
			...json.atelier,
			etat:
				toutesFacture && canClore
					? ATELIER_ETAT_CLOS
					: ATELIER_ETAT_EN_ATTENTE_PAIEMENT,
			transactionsv2: transactions,
		}
		// Revue 30.10 (F1) : la cause d'un refus du POST (thunk silencieux)
		// remonte dans la modale.
		const cause = () => {
			const e = dispatch(
				(_, getState) => getState().atelierInfo.postAtelier.error,
			)
			return (e && (e.message || e.msg)) || false
		}
		return dispatch(postAtelier(JSON.stringify(json)))
			.then((res) => {
				if (reloadFiche) reloadFiche()
				return res && res.atelier ? true : cause()
			})
			.catch(() => {
				if (reloadFiche) reloadFiche()
				return cause()
			})
	}

	return (
		<FacturationModalV2
			aFacturer={aFacturer.filter((t) => Number.isInteger(t.id))}
			lignesNonEnregistrees={lignesNonEnregistrees}
			champFiche={{ id: atelier.id }}
			onFactures={onFactures}
			onPasserEnAttente={() =>
				updateEtatAndSave(ATELIER_ETAT_EN_ATTENTE_PAIEMENT)
			}
			onClose={onClose}
		/>
	)
}

export default FacturationCustomModalV2
